import angular from "angular";

const DEFAULT_HEADERS = {
  // 'Accept': 'application/json',
  // 'Content-Type': 'application/x-www-form-urlencoded'
};

let HttpFactory = angular
  .module("HttpFactory", [])
  .factory("HttpFactory", ($rootScope, $http, $q, ngDialog) => {
    "ngInject";
    return {
      downloadFIle: function (url, params, fileName = "velos-print.pdf") {
        let defer = $q.defer();
        let req = {
          url: url,
          method: "GET",
        };

        if (params) {
          req.params = params;
        }

        /* Headers */
        req.headers = Object.assign(
          {
            "X-Accept-Language":
              window.localStorage.getItem("vLanguage") || "en",
          },
          DEFAULT_HEADERS
        );
        if ($rootScope.token) {
          req.headers.Authorization = "Bearer " + $rootScope.token;
        }
        req.responseType = "blob";

        $rootScope.isLoading = true;
        $http(req)
          .then(function (response) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName); //or any other extension
            document.body.appendChild(link);
            link.click();
            defer.resolve(response.data);
            $rootScope.isLoading = false;
          })
          .catch(function (error) {
            $rootScope.isLoading = false;
            ngDialog.open({
              template: "errorTemplate",
              data: {
                message: error.data.message,
              },
            });
            if (error.status === 401) {
              $rootScope.logout();
            }
            defer.reject(error);
          });
      },
      getPDF: function (url, params) {
        let req = {
          url: url,
          method: "GET",
          responseType: "arraybuffer",
        };

        if (params) {
          req.params = params;
        }

        /* Headers */
        req.headers = Object.assign(
          {
            "X-language": window.localStorage.getItem("vLanguage") || "en",
          },
          DEFAULT_HEADERS
        );
        if ($rootScope.token) {
          req.headers.Authorization = "Bearer " + $rootScope.token;
        }

        return $http.get(url, req);
      },
      get: function (url, params, silent = false) {
        let req = {
          url: url,
          method: "GET",
        };

        if (params) {
          req.params = params;
        }

        return this.makeRequest(req, silent);
      },
      post: function (url, body) {
        let req = {
          url: url,
          method: "POST",
        };
        if (body) {
          req.data = body;
        }
        return this.makeRequest(req);
      },
      put: function (url, body) {
        let req = {
          url: url,
          method: "PUT",
        };
        if (body) {
          req.data = body;
        }
        return this.makeRequest(req);
      },
      delete: function (url) {
        let req = {
          url: url,
          method: "DELETE",
        };
        return this.makeRequest(req);
      },
      makeRequest(req, silent = false) {
        let defer = $q.defer();

        /* Headers */
        req.headers = Object.assign(
          {
            "X-language": window.localStorage.getItem("vLanguage") || "en",
          },
          DEFAULT_HEADERS
        );
        if ($rootScope.token) {
          req.headers.Authorization = "Bearer " + $rootScope.token;
        }

        console.log(req);
        $rootScope.isLoading = !silent;
        $http(req)
          .then(function (response) {
            console.log(response.data);
            defer.resolve(response.data);
            $rootScope.isLoading = false;
          })
          .catch(function (error) {
            console.log(error);
            $rootScope.isLoading = false;
            ngDialog.open({
              template: "errorTemplate",
              data: {
                message: error.data.message,
              },
            });
            if (error.status === 401) {
              $rootScope.logout();
            }
            defer.reject(error);
          });

        return defer.promise;
      },
      buildUrl: function (url, keyValueReplace) {
        Object.entries(keyValueReplace).forEach((entry) => {
          let key = entry[0];
          let value = entry[1];
          url = url.replace("{" + key + "}", value);
        });
        return url;
      },
    };
  }).name;

export default HttpFactory;



// WEBPACK FOOTER //
// ./client/app/services/http.factory.js